import React, { Component } from "react";
import PropTypes from "prop-types";

import { Container } from "../../components/simple";
import { ActivateModal } from "../../components/forms/Auth/Activate";
import MessageModal from "../../components/complex/ModalMessage";

import Api from "../../api";
import { paramsToObject } from "../../api/params";
import * as routes from "../../router/routes";

import "../../styles/shared/unauthed.scss";

export default class ActivateScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSignUpModal: true,
      userData: {},
      userDataError: {}
    };
    this.activateUser = this.activateUser.bind(this);
    this.resetError = this.resetError.bind(this);
  }

  async componentDidMount() {
    try {
      const {
        location: { search }
      } = this.props;
      const data = paramsToObject(search);
      const { id } = await Api.user.invitedUser({
        data
      });
      const userData = await Api.user.deactivatedUser({ id });
      return this.setState({ userData });
    } catch (error) {
      if (error.response) {
        const { response } = error;
        return this.setState({
          userDataError:
            (response.data && response.data.detail) || response.data || error
        });
      }
      return this.setState({ userDataError: error });
    }
  }

  async activateUser(data) {
    try {
      const { history } = this.props;
      await Api.user.inviteActivate({ data });
      return history.push(routes.signIn);
    } catch (error) {
      if (error.response) {
        const { response } = error;
        return this.setState({
          userDataError:
            (response.data && response.data.detail) || response.data || error
        });
      }
      return this.setState({ userDataError: error });
    }
  }

  resetError() {
    this.setState({
      userDataError: {}
    });
  }

  render() {
    document.title = "Activate Account | Global Data Resources";
    const { isSignUpModal, userData, userDataError } = this.state;
    const { history } = this.props;

    const goBackActionSignUp = () => {
      this.setState({
        isSignUpModal: !isSignUpModal
      });
      history.goBack();
    };

    const signUpDefaultData = {
      ...userData,
      company: (userData.company && userData.company.name) || ""
    };
    return (
      <Container className="unauthed-container-background" fluid>
        {Object.keys(userData).length && (
          <ActivateModal
            isOpen={isSignUpModal}
            data={signUpDefaultData}
            fieldErrors={userDataError}
            handleChange={this.resetError}
            goBackAction={goBackActionSignUp}
            handleSubmit={this.activateUser}
          />
        )}

        {!Object.keys(userData).length && userDataError && (
          <MessageModal
            isOpen={userDataError}
            message={
              // eslint-disable-next-line no-nested-ternary
              typeof userDataError === "string"
                ? userDataError.length > 200
                  ? "Some error has occurred"
                  : userDataError
                : Object.keys(userDataError).length
                ? JSON.stringify(userDataError)
                : ""
            }
            goBackAction={() => {
              this.setState({ userDataError: "" });
              history.goBack();
            }}
          />
        )}
      </Container>
    );
  }
}

ActivateScreen.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
    push: PropTypes.func
  }).isRequired
};
